import {LIMITED_CONCURRENCY_PROJECTS, VERY_LIMITED_CONCURRENCY_PROJECTS} from 'common/report/constants';
import type {Dashboard} from 'common/report/dashboards/types';
import {scaleQueryConcurrency} from 'common/util/query-concurrency-scaling';

const MAX_CARDS_TO_LOAD_IMMEDIATELY = 10;

export function isLimited(projectId: string | undefined): boolean {
  return projectId !== undefined && LIMITED_CONCURRENCY_PROJECTS.has(projectId);
}

export function isVeryLimited(projectId: string | undefined): boolean {
  return projectId !== undefined && VERY_LIMITED_CONCURRENCY_PROJECTS.has(projectId);
}

export function isNotLimited(projectId: string | undefined): boolean {
  return !isLimited(projectId) && !isVeryLimited(projectId);
}

export function getMaxCardsToLoadImmediately(projectId?: string): number {
  if (isVeryLimited(projectId) || isLimited(projectId)) return 1;
  return MAX_CARDS_TO_LOAD_IMMEDIATELY;
}

export function getMaxConcurrentQueries(projectId?: string, dashboard?: Dashboard): number {
  const numCards = dashboard?.cards?.length ?? 0;
  if (isVeryLimited(projectId)) return 2;
  if (isLimited(projectId)) return 5;
  return scaleQueryConcurrency(numCards);
}
